import { Stack, Typography } from "@mui/material";
import { currencyFormatter } from "../../../helpers/currencyFormat";
import ProfileCard from "./ProfileCard";
import { useGetMe } from "../../../hooks";

const ProfileAccountBalance = () => {
  const { data: me } = useGetMe();

  const { accountBalance } = me || {};

  const accountBalanceFields = [
    {
      label: "Status",
      value: accountBalance?.status ? accountBalance.status : "N/A"
    },
    {
      label: "Maximum Balance Remaining",
      value: accountBalance?.maximumBalanceRemaining ? currencyFormatter(accountBalance.maximumBalanceRemaining, 2) : "N/A"
    },
    {
      label: "Balance Due if Paid Today",
      value: accountBalance?.balanceDueIfPaidToday ? currencyFormatter(accountBalance.balanceDueIfPaidToday, 2) : "N/A"
    },
    {
      label: "Number of Payments Made",
      value: accountBalance?.numberOfPaymentsMade ? accountBalance.numberOfPaymentsMade : "N/A"
    }
  ];

  return <ProfileCard title="Account Balance" maxWidth="900px">
    {accountBalanceFields.map((item, index) => (
      <Stack key={index} direction="row" spacing={2} width="100%" justifyContent="space-between" alignItems="center" sx={{ borderBottom: '1px solid #EDF0FC', paddingBottom: '10px'}}>
        <Typography variant="label1">{item.label}</Typography>
        <Typography variant="data">{item.value}</Typography>
      </Stack>
    ))}
  </ProfileCard>;
};

export default ProfileAccountBalance;